import compose from 'lodash/fp/compose';

import {
  canAdd,
  canPublish,
  canUpdate,
  paginate,
  selectable
} from '../plugins';
import flowsApi from '../../firebase/flows';
import PluggableModule from '../pluggable';

const flows = new PluggableModule('flow');

flows.extend({
  namespaced: true,
  actions: {
    async addFlow({ commit }, data) {
      commit(flows.con.FLOW_SUBMIT_INIT);
      try {
        const ref = await flowsApi.add(data);
        commit(flows.con.FLOW_CREATED, ref.id);
        commit(flows.con.FLOW_SUBMIT_DONE);
      } catch (error) {
        commit(flows.con.FLOW_SUBMIT_DONE);
        throw error;
      }
    },
    async cloneFlow({ commit, state }, data) {
      commit(flows.con.FLOW_SUBMIT_INIT);
      try {
        const ref = await flowsApi.add({ ...state.selected, ...data });
        commit(flows.con.FLOW_CREATED, ref.id);
        commit(flows.con.FLOW_SUBMIT_DONE);
      } catch (error) {
        commit(flows.con.FLOW_SUBMIT_DONE);
        throw error;
      }
    },
    async publishFlow({ commit }, { flowId, mode }) {
      commit(flows.con.FLOW_PUBLISH_INIT);
      try {
        await flowsApi.publish(flowId, mode);
        commit(flows.con.FLOW_PUBLISH_DONE);
      } catch (error) {
        commit(flows.con.FLOW_PUBLISH_DONE);
        throw error;
      }
    },
    async updateFlow({ commit }, data) {
      commit(flows.con.FLOW_SUBMIT_INIT);
      try {
        await flowsApi.update(data);
        commit(flows.con.FLOW_SUBMIT_DONE);
      } catch (error) {
        commit(flows.con.FLOW_SUBMIT_DONE);
        throw error;
      }
    }
  }
});

const hop = compose(
  canAdd(),
  canUpdate(),
  canPublish(),
  paginate('flows', {
    filterDefinition: {
      tags: 'array-contains'
    }
  }),
  selectable(flowsApi, false)
);

export default hop(flows);
